import { Card, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import {
  Chart as ChartJS,
  Legend,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';
import { useState, useEffect } from 'react';
import { Scatter } from 'react-chartjs-2';
import { fontsize15, poppins600 } from 'theme/common.style';
ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

function ScatterChart({ sector, list }) {
  const datasetcampaign = sector?.rightColumn?.campaign;
  const datasetmarket = sector?.rightColumn?.market;
  const [campaign, setcampaign] = useState(true);
  const [market, setmarket] = useState(true);
  useEffect(() => {
    if (!list?.length) return;
    list.forEach((item) => {
      if (item?.datasetlabel == 'Campaign') {
        setcampaign(item?.visible);
      }
      if (item?.datasetlabel == 'Market') {
        setmarket(item?.visible);
      }
    });
  }, [list]);

  const theme = useTheme();
  const matches500 = useMediaQuery(theme.breakpoints.down(500));

  const data = {
    datasets: [
      campaign && {
        label: 'Campaign',
        data: [
          {
            x: 'Lowest',
            y: datasetcampaign?.lowestOffer,
          },
          {
            x: 'Median',
            y: datasetcampaign?.medianOffer,
          },
          {
            x: 'Highest',
            y: datasetcampaign?.highestOffer,
          },
        ],
        borderColor: '#0077b6',
        backgroundColor: 'rgb(0, 119, 182, 0.2)',
        pointRadius: 10,
      },
      market && {
        label: 'Market',
        data: [
          {
            x: 'Lowest',
            y: datasetmarket?.averageLowestOffer,
          },
          {
            x: 'Median',
            y: datasetmarket?.averageMedianOffer,
          },
          {
            x: 'Highest',
            y: datasetmarket?.averageHighestOffer,
          },
        ],
        borderColor: 'rgb(153, 102, 255)',
        backgroundColor: 'rgb(153, 102, 255 , 0.2)',
        pointRadius: 6,
      },
    ].filter(Boolean),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          title: (items) => items?.[0]?.label ?? '',
        },
      },
    },
    scales: {
      x: {
        type: 'category',
      },
    },
  };
  return (
    <Grid
      style={{
        display: 'flex',
        paddingTop: '5px',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%',
        minWidth: '100%',
      }}
    >
      <Card
        style={{
          borderRadius: '8px',
          padding: '15px',
          margin: '10px',
          height: '100%',
          boxShadow: 'none',
          minWidth: '98%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: '#ffff',
          gap: '20px',
        }}
      >
        <Grid item display={'flex'} justifyContent={'left'}>
          <Typography
            sx={{ ...poppins600, fontSize: matches500 ? '12px' : undefined }}
          >
            {' '}
            Offer range comparison to Market
          </Typography>
        </Grid>
        <Grid
          sx={{
            flex: 1,
            minHeight: 0,
            position: 'relative',
          }}
        >
          <Scatter data={data} options={options}></Scatter>
        </Grid>
      </Card>
    </Grid>
  );
}

export default ScatterChart;
